module.exports = {"id":"190637","name":"Igor Armaş","rating":"73","photo":"./data/images/photos/2/190637.png","club":{"name":"Anzhi Makhachkala","logo":"./data/images/clubs/AnzhiMakhachkala.png"},"positions":["DC","DG"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/IgorArmas0.json
// module id = 1786
// module chunks = 0